<template>
  <layout
    title="Versicherungen"
    :banner="$page.props.banner"
    h1="Versicherungen"
    metaDescription="Reiseversicherungen der Hanse Merkur - Wir bieten mit unserem Partner, der Hanse Merkur, zahlreiche Versicherungen rund um euren Urlaub. Informiert euch hier." 
    metaKeywords="SCOL, SCOL Skireisen, SCOL Reiseversicherung, Skireise Versicherung, Reiserücktrittversicherung, Skireise Hilfe"
  >
    <section id="versicherungen-content">
      <div class="scol-section bg-light">
        <div class="container">
          <div class="text-center">
            <h2 class="text-secondary">Reiseversicherungen der Hanse Merkur</h2>
          </div>
          <div class="row mt-5">
            <div class="col-md-6">
              <p>
                Gemeinsam mit unserem Partner HanseMerkur bieten wir euch zahlreiche Versicherungen rund um euren Urlaub, vom Reiserücktritt bis zur Reisekranken- und Gepäckversicherung. So seid ihr für alle Fälle gut abgesichert. Sprecht uns gerne an, wir beraten euch!
              </p>
            </div>
            <div class="col-md-12 mt-4">
                <iframe
                  id="fancybox-frame"
                  name="fancybox-frame1390301726382"
                  frameborder="0"
                  hspace="0"
                  scrolling="auto"
                  src="https://secure.hmrv.de/rvw-ba/initBa.jsp?baid=333&adnr=3298593&locale=de_DE"
                  class="w-100"
                  style="min-height: 500px;"
                ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
